import { TableCellTypes } from '@carboledger/ui';
import { makeLinkCell, makeUnitTypeCell, makeUnitScopedCell } from '@/components/common';
import { INVENTORY_COLUMNS, INVENTORY_SORT_FIELDS } from './inventory.constants';
import { buildRowUnitOptions, unitTypeLabel } from './inventoryUnits';

const renderUnitTypeCell = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));
const renderAvailableQuantity = makeUnitScopedCell('availableQuantity');

const sortable = (id) => Boolean(INVENTORY_SORT_FIELDS[id]);

export const buildInventoryColumns = (t, { unitHeaderSelect, onOpenMaterial }) => [
  {
    id: INVENTORY_COLUMNS.serialNo,
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 80,
    pinnable: true,
    sortable: sortable(INVENTORY_COLUMNS.serialNo),
  },
  {
    id: INVENTORY_COLUMNS.materialName,
    header: t('FIELD_MATERIAL_NAME'),
    type: TableCellTypes.custom,
    width: 200,
    pinnable: true,
    sortable: sortable(INVENTORY_COLUMNS.materialName),
    cell: makeLinkCell(onOpenMaterial),
  },
  {
    id: INVENTORY_COLUMNS.materialId,
    header: t('FIELD_MATERIAL_ID'),
    type: TableCellTypes.text,
    width: 160,
    sortable: sortable(INVENTORY_COLUMNS.materialId),
  },
  {
    id: INVENTORY_COLUMNS.materialRole,
    header: t('FIELD_MATERIAL_ROLE'),
    type: TableCellTypes.text,
    width: 140,
    sortable: sortable(INVENTORY_COLUMNS.materialRole),
  },
  {
    id: INVENTORY_COLUMNS.facilityName,
    header: t('FIELD_SITE_OR_B2B_ACCOUNT_NAME'),
    type: TableCellTypes.text,
    width: 200,
    sortable: sortable(INVENTORY_COLUMNS.facilityName),
  },
  {
    id: INVENTORY_COLUMNS.terminal,
    header: t('FIELD_TERMINAL'),
    type: TableCellTypes.text,
    width: 141,
    sortable: sortable(INVENTORY_COLUMNS.terminal),
  },
  {
    id: INVENTORY_COLUMNS.unitType,
    header: t('FIELD_UNIT_TYPE', { unit: unitTypeLabel(t, unitHeaderSelect.value) }),
    type: TableCellTypes.custom,
    width: 252,
    cell: renderUnitTypeCell,
    headerSelect: unitHeaderSelect,
  },
  {
    id: INVENTORY_COLUMNS.availableQuantity,
    header: t('FIELD_AVAILABLE_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    cell: renderAvailableQuantity,
  },
];
